<template>
  <PageContent>
    <StepsV2 type="s4" :step="3" />
    <PanelV2
      type="w6"
      title="You need to open a BDO or BDO Network Bank Account"
      @nextClick="next()"
    >
      <template v-slot:title-solt>
        <!-- <BdoProgress  /> -->
      </template>
      <template v-slot:content-solt>
        <bdo-no-account></bdo-no-account>
      </template>
    </PanelV2>
  </PageContent>
</template>

<script>
import BdoNoAccount from "./common/BdoNoAccount.vue";

export default {
  name: "IndividualM",
  components: {
    BdoNoAccount,
  },
  data() {
    return {};
  },
  methods: {
    next() {
      this.$router.push({ path: "/individual-j" });
    },
  },
};
</script>


<style lang="scss">
.el-form.SolePropI {
  .el-form-item:nth-child(4) {
    margin-top: -120px;
  }
}
</style>
